var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('transition',{attrs:{"name":"footer__share"}},[_c('div',{staticClass:"footer__share"},[_c('div',{staticClass:"share"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }